<template>
    <div id="new-contract-app-entry">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
